module.exports = __webpack_public_path__ + "img/realTime.9fed8513.png";